import { FC, useState, useMemo } from "react"
import { ChangeInputType } from "../../../api/EventTypes"

interface ISwitch {
  callback?: (checked: boolean, name: string) => void
  identifier: string
  name: string
  label: string
  checked?: boolean
  size?: "lg"
  disabled?: boolean
  className?: string
}

const SwitchBtn: FC<ISwitch> = (props) => {
  const [checked, setChecked] = useState(false)
  useMemo(() => {
    setChecked(props.checked)
  }, [props.checked])

  const onChange = (e: ChangeInputType) => {
    const { checked, name } = e.target
    setChecked(checked)
    props.callback && props.callback(checked, name)
  }
  return (
    <section className={`ocs-switch ${props.className ? props.className : ""}`}>
      <span className="ocs-switch-text">{props.label}</span>
      <input
        className="ocs-switch-input"
        type="checkbox"
        name={props.name}
        id={props.identifier}
        onChange={onChange}
        checked={checked}
        disabled={props.disabled}
      />

      <label
        className={`ocs-switch-label ${props.size ? props.size : ""}`}
        htmlFor={props.identifier}
      />
    </section>
  )
}

export default SwitchBtn
